import React, { useEffect, useState } from 'react'
import { QrTemplate } from '../components/QrTemplate'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { getQrIdentecoTrupo, postQrIdentecoTrupo } from '../../../services/qr';
import { useTranslation } from 'react-i18next';
import Loading from '../../../Components/Generic/Loading';

export const QrIdentecoTrupo = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [customData, setCustomData] = useState(null)
  const [sections, setSections] = useState()
  const [qrModel, setQrModel] = useState(null)
  const [loading, setLoading] = useState(false)
  const [attributes, setAttributes] = useState()
  const [qrModelLogo, setQrModelLogo] = useState(null)
  const [qrModelTheme, setQrModelTheme] = useState(null)
  const [qrModelLogoWoText, setQrModelThemeWoText] = useState(null)
  const [errorMessage, setErrorMessage] = useState({
    flag: false,
    message: ''
  })
  const backgroundColor = qrModelTheme?.background?.default ?? '#fff'

  useEffect(() => {
    setLoading(true)
    getQrIdentecoTrupo(id)
      .then(res =>{ 
        if (res.status === 206) {
          setQrModel(res.data.model ? res.data.model : null)
          return setErrorMessage({
            flag: true,
            message: res.data.message ? res.data.message : res.data
          })
        } else { 
          setCustomData(res.data.customData)
          setAttributes(res.data.attributes) 
          setQrModelTheme(res.data.theme?.theme?.blueTheme)
          setQrModelLogo(res.data.theme?.logo?.url)
          setQrModelThemeWoText(res.data.theme?.logoWoText?.url)
          setSections(res.data.sections)
        }
      })
      .catch(err => {
        console.log('Error getQrIdenteco', err)
        setErrorMessage({
          flag: true,
          message: ''
        })
      })
      .finally(() => {
        setLoading(false)
      })
    postQrIdentecoTrupo(id)
  }, [id]);

  return (
    <div
      style={{
        backgroundColor,
        minHeight: '100vh',
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
    {loading ? (
      <Loading/>
    ) : (
      <QrTemplate
        customData={customData}
        sections={sections}
        attributes={attributes}
        qrModelTheme={qrModelTheme}
        qrModelLogo={qrModelLogo}
        qrModelLogoWoText={qrModelLogoWoText}
        editMode={false}
        errorMessage={ errorMessage.flag ? 
          (errorMessage.message ? t(`template.error.${errorMessage.message}`) : t('template.error.default')) : ''
        }
        qrErrorImg={qrModel ? `/images/qrErrors/errorImg${qrModel}.png` : null}
      />
    )}
    </div>
  )
}
